import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import React from 'react';

import { useMenu } from 'hooks';
import { properCase } from 'lib/utils';

const LotteryDrawItem = ({
	lotteryDraw,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(lotteryDraw, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(lotteryDraw, e)}>
				Delete
			</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(lotteryDraw.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(lotteryDraw)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(lotteryDraw)}
						name="lotteryDraw"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Typography variant="primary.text">
					{lotteryDraw?.user?.first_name} {lotteryDraw?.user?.last_name}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{properCase(lotteryDraw.status)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{lotteryDraw.created_at}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<Edit />
					<Delete />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default LotteryDrawItem;
